/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { PromoActionBonusType } from './PromoActionBonusType'
import {
  PromoActionBonusTypeFromJSON,
  PromoActionBonusTypeFromJSONTyped,
  PromoActionBonusTypeToJSON,
} from './PromoActionBonusType'

/**
 * Промокод со случайной промо-акцией
 * @export
 * @interface RandomPromoAction
 */
export interface RandomPromoAction {
  /**
   * Код промокода
   * @type {string}
   * @memberof RandomPromoAction
   */
  code: string
  /**
   * Дата начала действия промокода (текущий момент создания)
   * @type {Date}
   * @memberof RandomPromoAction
   */
  startAt: Date
  /**
   * Дата окончания действия промокода (месяц с момента создания)
   * @type {Date}
   * @memberof RandomPromoAction
   */
  expireAt: Date
  /**
   * Название промо-акции
   * @type {string}
   * @memberof RandomPromoAction
   */
  promoActionName: string
  /**
   * Бонус акции: percent — процент скидки (10–100), fixed — сумма в рублях (500–3000), service — текст бесплатной услуги
   * @type {string}
   * @memberof RandomPromoAction
   */
  bonus: string
  /**
   *
   * @type {PromoActionBonusType}
   * @memberof RandomPromoAction
   */
  bonusType: PromoActionBonusType
}

/**
 * Check if a given object implements the RandomPromoAction interface.
 */
export function instanceOfRandomPromoAction(
  value: object
): value is RandomPromoAction {
  if (!('code' in value) || value['code'] === undefined) return false
  if (!('startAt' in value) || value['startAt'] === undefined) return false
  if (!('expireAt' in value) || value['expireAt'] === undefined) return false
  if (!('promoActionName' in value) || value['promoActionName'] === undefined)
    return false
  if (!('bonus' in value) || value['bonus'] === undefined) return false
  if (!('bonusType' in value) || value['bonusType'] === undefined) return false
  return true
}

export function RandomPromoActionFromJSON(json: any): RandomPromoAction {
  return RandomPromoActionFromJSONTyped(json, false)
}

export function RandomPromoActionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RandomPromoAction {
  if (json == null) {
    return json
  }
  return {
    code: json['code'],
    startAt: new Date(json['startAt']),
    expireAt: new Date(json['expireAt']),
    promoActionName: json['promoActionName'],
    bonus: json['bonus'],
    bonusType: PromoActionBonusTypeFromJSON(json['bonusType']),
  }
}

export function RandomPromoActionToJSON(value?: RandomPromoAction | null): any {
  if (value == null) {
    return value
  }
  return {
    code: value['code'],
    startAt: value['startAt'].toISOString(),
    expireAt: value['expireAt'].toISOString(),
    promoActionName: value['promoActionName'],
    bonus: value['bonus'],
    bonusType: PromoActionBonusTypeToJSON(value['bonusType']),
  }
}
